const getAttestations = (state) => state.attestations;
const attestationLang = (state) => state.attestationLang;

export default {
  getAttestations,
  attestationLang,
};
